import moment from 'moment';

export const getDatesDuration = (start, end, precise = false) =>
  moment(end).diff(start, 'days', precise);

export const isInRangeCheck = (stripRange, startRange, endRange) =>
  moment(startRange).isBetween(...stripRange) ||
  moment(endRange).isBetween(...stripRange);
